import React from 'react';
import PropTypes from 'prop-types';
export const Capacity = ({amount}) =>{
	return(
		<>
			Maximum capacity: <b>{amount}</b>
		</>
	)

}
Capacity.propTypes = {
	amount: PropTypes.number
};
